import { createSelector, Selector } from "@ngxs/store";
import { DataState, DataStateModel } from "./data.state";

export class DataSelectors {
    static staffList(objectcd: string) {
        return createSelector(
            [DataState],
            (state: DataStateModel) => state.staffList[objectcd]
        );
    }

    static userList(objectcd: string) {
        return createSelector(
            [DataState],
            (state: DataStateModel) => state.userList[objectcd]
        );
    }

    static userGroupList(objectcd: string) {
        return createSelector(
            [DataState],
            (state: DataStateModel) => state.userInGroupList[objectcd]
        );
    }

    static staffTeamList(objectcd: string) {
        return createSelector(
            [DataState],
            (state: DataStateModel) => state.staffInTeamList[objectcd]
        );
    }

    static userImage(daicd: string) {
        const joinStringCharater = '@@@';
        return createSelector(
            [DataState],
            (state: DataStateModel) => state.userImage[daicd]?.split(joinStringCharater)[0]
        );
    }

    static allRecords() {
        return createSelector(
            [DataState],
            (state: DataStateModel) => state.allRecords
        );
    }

    @Selector([DataState])
    static selectedUser(state: DataStateModel) {
        return state.selectedUser;
    }

    @Selector([DataState])
    static personalSetting(state: DataStateModel) {
        return state.personalSetting;
    }

    @Selector([DataState])
    static getBDRoleList(state: DataStateModel) {
        return state.bdRoleList;
    }

    @Selector([DataState])
    static getUnsave(state: DataStateModel) {
        return state.unsave;
    }

    @Selector([DataState])
    static userByUnitList(state: DataStateModel) {
        return state.userByUnitList;
    }

    @Selector([DataState])
    static careConneRoomAllList(state: DataStateModel) {
        return state.careConneRoomList;
    }

    static careConneRoomList(daicd: string) {
        return createSelector(
            [DataState],
            (state: DataStateModel) => state.careConneRoomList[daicd]
        );
    }

    static careConneRoomListByObjcd(daicd: string, objcd: string) {
        return createSelector(
            [DataState],
            (state: DataStateModel) => state.careConneRoomList[daicd].roomDataByUnit.find((item) => item.objcd === objcd)
        );
    }

    @Selector([DataState])
    static renderedDataNote(state: DataStateModel) {
        return state.renderedDataNote;
    }
}